var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFavourite(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 42 39' }, props),
        React.createElement("path", { d: 'M30.448.25c-3.047 0-5.907 1.54-8.561 4.56a1.25 1.25 0 01-1.873.007l-.278-.307C17.146 1.69 14.652.25 12.234.25 5.744.25.25 4.866.25 13.315c0 6.403 6.36 14.46 19.02 24.317a2.75 2.75 0 003.406-.021l.502-.403C35.633 27.18 41.883 19.273 41.883 13.315 41.883 5.027 36.937.25 30.448.25zm0 1.5c5.672 0 9.935 4.118 9.935 11.565 0 5.34-6.033 12.972-18.144 22.723l-.5.402a1.25 1.25 0 01-1.548.008C7.877 26.86 1.75 19.1 1.75 13.315 1.75 5.758 6.52 1.75 12.234 1.75c1.926 0 4.064 1.235 6.394 3.77l.27.298a2.749 2.749 0 004.116-.018c2.39-2.72 4.86-4.05 7.434-4.05z' })));
}
export default SvgFavourite;
//# sourceMappingURL=Favourite.js.map